import React from 'react';
import Login from './noLoggued/Login';

function LoginJS(props) {

    const handleClose = () => {
        window.$('#login_modal_form').modal('hide');
        //window.$('#login_modal_form').modal('dispose');
    }

    return (
        <div
            className="modal fade"
            id={`login_modal_form`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body">
                        <Login onClose={handleClose} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginJS;